import BuildingTitle from './BuildingTitle';

export default BuildingTitle;



// WEBPACK FOOTER //
// ./src/components/Header/BuildingTitle/index.js